import { useUser } from '@vivaldis/session'
import { useMemo } from 'react'

export const useUserConstructFourDCompanyId = () => {
  const user = useUser()
  return useMemo(() => {
    const permission = user?.permissions.find(
      permission => permission.companyId === user?.company?.id
    )

    return permission?.construct4dPermissions?.id
  }, [user?.company?.id, user?.permissions])
}
